import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'

import { CSSTransition } from 'react-transition-group'

import useOuterClickListener from '@aytm/lib/rfd-ui/lib/outer-click-listener'

import './Overlay.scss'

const CLASS = 'insights-portal-overlay'

const Overlay = props => {
  const contentRef = useRef(null)

  const className = useMemo(() => {
    let result = CLASS
    if (props.className) result += ` ${props.className}`
    return result
  }, [props.className])

  useOuterClickListener({
    ref: contentRef,
    listen: props.show,
    onClick: event => {
      if (props.onOuterClick) {
        props.onOuterClick(event)
      }
    },
    onKeyDown: event => {
      if (props.onKeyDown) {
        props.onKeyDown(event)
      }
    }
  })

  const onEnter = event => {
    if (props.onEnter) {
      props.onEnter(event)
    }
  }

  const onExit = event => {
    if (props.onExit) {
      props.onExit(event)
    }
  }

  return (
    <CSSTransition
      in={props.show}
      nodeRef={contentRef}
      timeout={200}
      classNames={CLASS}
      unmountOnExit
      onEnter={onEnter}
      onExited={onExit}
    >
      <div ref={contentRef} className={className}>
        {props.children}
      </div>
    </CSSTransition>
  )
}

Overlay.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  show: PropTypes.any,
  timeout: PropTypes.number,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  onOuterClick: PropTypes.func,
  onKeyDown: PropTypes.func
}

Overlay.defaultProps = {
  timeout: 300
}

export default Overlay
